module.exports = __webpack_public_path__ + "img/1_035.6ffd68fa.jpg";